<template>
  <div class="tcp">
    <div class="tcp_infos" v-show='isShow'>
      <h2>月卡连续包月/包季/包年服务规则</h2>
      <br>
      <p class="title_info">本月卡连续包月/包季/包年服务规则，简称月卡自动续费服务规则，（下称"本规则"）被视为《上海吾声网络科技有限公司服务协议》的附件，如本规则与《上海吾声网络科技有限公司服务协议》存在冲突的，以本规则为准。</p>
      <p class="tcp_rules">如您需使用月卡连续包月/包季/包年服务，则需同意本规则。</p>
      <p class="tcp_agree">您理解并同意：</p>
      <p class="item">1、月卡连续包月/包季/包年服务（下称"本服务"）是指在您已开通月卡的前提下，为您提供的自动续费服务。如您开通本服务，则视为您授权我是谜在您月卡即将到期时，从您的自有充值账户、绑定的第三方支付账户、银行卡、苹果账户（以下统称"账户"）中代扣下一个计费周期服务费。该服务实现的前提是您已开通及绑定账户，且可成功从上述账户中扣款，因上述账户中可扣款余额不足导致的续费失败等风险及/损失，由您自行承担。</p>
      <p class="item">2、本服务由您自主选择是否取消，若您选择不取消，则视为您同意我是谜按照本规则进行代扣款项的续费尝试，一旦扣款成功，我是谜将为您开通下一个计费周期的月卡。若在自动续费时/前，月卡价格发生调整，应以现时有效的价格为准。</p>
      <p class="item">3、本服务自您开通之曰起长期有效，直至您自主选择取消本服务/月卡到期时终止。</p>
      <p class="item">4.购买月卡后，每日登陆可在签到页领取15钻石奖励；若登陆当日您没有主动领取则视为放弃当日奖励;若当日您没有登陆,同样也将视为放弃当日奖励。若在月卡生效期间，每日奖励发生调整,应以现时有效的钻石奖励为准。</p>
      <p class="item">5、您可通过下述方式取消本服务：
        <br>【ApplelD购买】请手动打开iPhone或IPad"设置"->进入"iTunes Store与App Store"->点击"Apple ID",选择"查看Apple ID"，进入"账户设置"页面，点击"订阅"，选择我是谜，取消相应订阅即可。如未在计费周期到期前至少24小时前取消自动续期订阅，那么将会自动续订并扣款。
      </p>
      <p
        class="item_last"
      >本服务取消成功后，不影响您当月/季/年已成功扣费且生效的月卡权益，月卡到期后不再续费。您在选择终止本服务前已经委托我是谜自动续费扣款的指令仍然有效，我是谜对于基于该指令扣除的费用不予退还，由您自行承担相关责任。</p>
      <p class="name">我是谜</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "TcpRoules",
  data(){
      return{
          isShow:false
      }
  },
  created() {
    document.getElementsByTagName("title")[0].innerText =
      "我是谜-月卡自动续费服务规则";
  },
  mounted(){
     this.isShow=true
  },
  
};
</script>

<style scoped>
.tcp {
  width: 100%;
  height: 100%;
  display: flex;
  font-weight: 12.5rem;
}
.tcp .tcp_infos {
  justify-content: center;
  margin-left: 1.25rem;
  margin-right: 1.25rem;
  margin-top: 1.5rem;
}
.tcp .tcp_infos h2 {
  font-size: 0.75rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.375rem;
}
.tcp .tcp_infos .title_info {
  text-indent: 2em;
  font-size: 0.625rem;
  margin-bottom: 0.25rem;
  word-break: break-all;
  padding: 0 0 0.125rem 0;
}
.tcp .tcp_infos .tcp_rules {
  text-indent: 2em;
  font-size: 0.625rem;
  margin-bottom: 0.25rem;
}
.tcp .tcp_infos .tcp_agree {
  text-indent: 2em;
  font-size: 0.625rem;
}
.tcp .tcp_infos .item {
  text-indent: 2em;
  font-size: 0.625rem;
  margin-top: 0.25rem;
}
.tcp .tcp_infos .name {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
  text-align: right;
  font-size: 0.75rem;
  font-weight: bold;
}
.tcp .tcp_infos .item_last {
  text-indent: 2em;
  font-size: 0.625rem;
  margin-top: 0.375rem;
}
/* 其他组件中的内容无需更改 */
</style>




// WEBPACK FOOTER //
// src/tcp/server_rules.vue